module.exports = __webpack_public_path__ + "static/media/next.287f1413.svg";